import moment from 'moment'

/**
 * The moment an error was shown, in UTC, as `28-Sep-2026, 10:07:42 UTC`.
 * Every error toast carries it so a screenshot or a report of an error says
 * when it happened, in a timezone that matches the server logs. The date part
 * follows the app's display format (`formatDateTimeToShow`); the time keeps
 * seconds because that is what you grep the logs for.
 */
export const formatUtcTimestamp = (now: Date = new Date()): string =>
  moment.utc(now).format('DD-MMM-YYYY, HH:mm:ss [UTC]')
